import React, { useCallback } from 'react';
import classes from 'classnames';
import Ellipse2 from '@/assets/svg/Ellipse 2.svg';
import Ellipse3 from '@/assets/svg/Ellipse 3.svg';
import Ellipse4 from '@/assets/svg/Ellipse 4.svg';
import Ellipse5 from '@/assets/svg/Ellipse 5.svg';
import classNames from './GoToTutor.module.scss';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@/store';
import { levelTestActions } from '@/store/reducers/level-test';
import { authSelector } from '@/store/reducers/auth';
import UseScreenSize from '@/hooks/UseScreenSize';
import DOMPurify from 'dompurify';

interface GoToTutorProps {
  text?: string;
  layout?: 'row' | 'column';
}

const GoToTutor = ({ text, layout = 'row' }: GoToTutorProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isMobile } = UseScreenSize();
  const { user } = useAppSelector(authSelector);
  const firstName = user?.metadata?.firstName ?? '';

  const onEmitOnClick = useCallback(() => {
    dispatch(levelTestActions.setActivity(null));
    navigate('/dashboard/my-tutor-chat');
  }, [navigate, dispatch]);

  return (
    <div className={classes(classNames.banner, classNames['banner--card'])}>
      <img
        src={isMobile ? Ellipse3 : Ellipse5}
        className={classNames.ellipseBack}
        aria-hidden='true'
      />
      <img
        src={isMobile ? Ellipse2 : Ellipse4}
        className={classNames.ellipseFront}
        aria-hidden='true'
      />
      <div className={classNames.cardContent}>
        <div
          className={classNames.greeting}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(t('tutorNewConversation', { name: firstName }) || ''),
          }}
        />
      </div>
      <button onClick={onEmitOnClick} className={classNames.startButton}>
        {t('startNewConversation')}
      </button>
    </div>
  );
};

export default GoToTutor;
